import { Image } from "@mui/icons-material";
import './index.css';

const ENEAlogo = ()=>{
    
    return (
        <div className="to-print">
            <a href="https://www.enea.it">
                <img width={150} src="https://www.enea.it/images/layout/logoenea1.png" alt="logo ENEA"/>
            </a>
        </div>);
}

export default ENEAlogo;